interface CrossWhiteBgProps {
  height?: string;
  width?: string;
}

export function CrossWhiteBg(props: CrossWhiteBgProps) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || "16"}
        height={props.height || "16"}
        viewBox="0 0 16 16"
        fill="none"
      >
        <rect width="16" height="16" rx="8" fill="white" />
        <path
          d="M10.6553 4.875C10.7825 4.87503 10.8945 4.92384 10.9854 5.01465C11.0762 5.10545 11.125 5.2175 11.125 5.34473C11.125 5.47195 11.0761 5.58399 10.9854 5.6748L8.66016 8L10.9854 10.3252C11.0761 10.416 11.125 10.528 11.125 10.6553C11.125 10.7825 11.0762 10.8945 10.9854 10.9854C10.8945 11.0762 10.7825 11.125 10.6553 11.125C10.528 11.125 10.416 11.0761 10.3252 10.9854L8 8.66016L5.6748 10.9854C5.58399 11.0761 5.47195 11.125 5.34473 11.125C5.2175 11.125 5.10545 11.0762 5.01465 10.9854C4.92384 10.8945 4.87503 10.7825 4.875 10.6553C4.875 10.528 4.92388 10.416 5.01465 10.3252L7.33984 8L5.01465 5.6748C4.92388 5.58399 4.875 5.47195 4.875 5.34473C4.87503 5.2175 4.92384 5.10545 5.01465 5.01465C5.10545 4.92384 5.2175 4.87503 5.34473 4.875C5.47195 4.875 5.58399 4.92388 5.6748 5.01465L8 7.33984L10.3252 5.01465C10.416 4.92388 10.528 4.875 10.6553 4.875Z"
          fill="#00775E"
          stroke="#00775E"
          strokeWidth="0.25"
        />
      </svg>
    </>
  );
}
